import {Zp, ZpDate} from "./Zp";
import {Detail} from "./Detail";
import Coordinates = JQuery.Coordinates;

export class ZpCalendar {
    private firstMonth: ZpDate;
    private readonly clickEvent?: (el: JQuery<HTMLLIElement>, zpDate: ZpDate) => void;
    private readonly hoverEvent?: (el: JQuery<HTMLLIElement>, zpDate: ZpDate, onover: boolean) => void;
    private lastMarkFrom: ZpDate = 0;
    private lastMarkTill: ZpDate = 0;
    readonly calendarDiv: JQuery<HTMLElement>;
    private readonly cols: number = 2;
    availStart: ZpDate = 0;
    availData: string = "";

    constructor(startDay?: ZpDate, clickEvent?: (el: JQuery<HTMLLIElement>, zpDate: ZpDate) => void, hoverEvent?: (el: JQuery<HTMLLIElement>, zpDate: ZpDate, onover: boolean) => void, cols?: number) {
        if (cols) this.cols = cols;
        if (!startDay) startDay = Zp.today();
        const p = Zp.toParts(startDay);
        p.day = 1;
        this.firstMonth = Zp.fromParts(p);
        this.clickEvent = clickEvent;
        this.hoverEvent = hoverEvent;
        this.calendarDiv = $('<div id="calZp" class="calendar-document"></div>').append(this.buildCalendar());
        this.calendarDiv.on('selectstart', function (ev) {
            ev.preventDefault();
        });
    }

    availStatus(zp: ZpDate): number { // return 0 = unbekannt, 1 = frei, -1 = belegt
        const index = zp - this.availStart;
        if (index < 0 || index >= this.availData.length) return 0;
        if (this.availData[index] === "0") return -1;
        if (this.availData[index] !== "0") return 1;
        return 0;
    }

    posRefElement(main: JQuery<HTMLElement>, el: JQuery<HTMLElement>, ofs?: Coordinates & { arrOfs?: number }) {
        const p = el.offset();
        const pel = main.offset();
        p.left -= pel.left;
        p.top -= pel.top;
        if (ofs) {
            p.left += ofs.left;
            p.top += ofs.top;
            if (typeof ofs.arrOfs === "number") {
                const arr = this.calendarDiv.find(".cal-arrow");
                if (arr.length) arr[0].style.left = `${30 + ofs.arrOfs}px`;
            }
        }
        this.calendarDiv.css({top: p.top + "px", left: p.left + "px"});
    }

    markDays(zpFrom: ZpDate, zpTill: ZpDate) {
        if (zpFrom > zpTill) {
            const tmp = zpFrom;
            zpFrom = zpTill;
            zpTill = tmp;
        }
        this.lastMarkFrom = zpFrom;
        this.lastMarkTill = zpTill;

        const lis = this.calendarDiv.find("li[data-date]");
        lis.removeClass("cal-check-in cal-between cal-check-out");
        lis.each(function () {
            const el = $(this);
            const d = el.data("date");
            if (d >= zpFrom && d <= zpTill) {
                if (d == zpFrom) el.addClass("cal-check-in");
                else if (d == zpTill) el.addClass("cal-check-out");
                else el.addClass("cal-between");
            }
        });
    }

    private static _buildCalendarMonthScaffold(zpDate: ZpDate, appendTo: JQuery<HTMLElement>, cols: number): JQuery<HTMLElement> {
        const parts = Zp.toParts(zpDate);

        const calMon = $('<div class="cal-month pull-left"' + (cols !== 2 ? ' style="width:' + (100 / cols) + '%"' : "") + '></div>');
        calMon.append('<div class="cal-header"><div class="cal-title"><span class="cal-title-month">' + Zp.monthName[Zp.cult][parts.month] + '</span> <span class="cal-title-year">' + parts.year + '</span></div></div>');

        let wd = "";
        for (let i = 0; i < 7; i++) wd += "<i>" + Zp.weekdayShortName[Zp.cult][(i + Zp.weekdayStart[Zp.cult]) % 7] + "</i>";
        const calBody = $('<div class="cal-body"><div class="cal-week-names clearfix">' + wd + '</div></div>');
        calMon.append(calBody);

        const calDays = $('<ul class="cal-days clearfix"></ul>');
        calBody.append(calDays);

        calMon.appendTo(appendTo);

        return calDays;
    }

    buildCalendar(): JQuery<HTMLElement> {
        const cal = `<div class="calendar-modern">
            <div class="cal-arrow" style="left: 30px;"></div>
            <div class="cal-wrapper"` + (this.cols !== 2 ? " style=\"width:" + (this.cols * 17).toFixed(0) + "em\"" : "") + `>
                <div class="cal-months clearfix">
                </div>
                <div class="cal-nav">
                    <a class="cal-prev"><i class="css-icons" data-icon="" data-icon-text="keyboard_arrow_left"></i></a>
                    <a class="cal-next"><i class="css-icons" data-icon="" data-icon-text="keyboard_arrow_right"></i></a>
                </div>
            </div>
        </div>`;

        const tab = $(cal);
        tab.find(".cal-prev").on("click", (ev) => {
            this.calendarDiv.empty();
            const p = Zp.toParts(this.firstMonth);
            p.month--;
            if (p.month < 1) {
                p.month += 12;
                p.year--;
            }
            this.firstMonth = Zp.fromParts(p);
            this.calendarDiv.append(this.buildCalendar());
            this.markDays(this.lastMarkFrom, this.lastMarkTill);
            ev.preventDefault();
        });
        tab.find(".cal-next").on("click", (ev) => {
            this.calendarDiv.empty();
            const p = Zp.toParts(this.firstMonth);
            p.month++;
            if (p.month > 12) {
                p.month -= 12;
                p.year++;
            }
            this.firstMonth = Zp.fromParts(p);
            this.calendarDiv.append(this.buildCalendar());
            this.markDays(this.lastMarkFrom, this.lastMarkTill);
            ev.preventDefault();
        });

        const todayLimit = Zp.today() + 2;
        if (!this.firstMonth) this.firstMonth = todayLimit;

        let d = this.firstMonth;
        const p = Zp.toParts(d);
        p.day = 1;
        d = Zp.fromParts(p);

        if (Detail.data && Detail.data.vacancy && Detail.data.vac_start) {
            this.availStart = Detail.data.vac_start;
            this.availData = Detail.data.vacancy;
        }

        for (let months = 0; months < this.cols; months++) {
            const calDays = ZpCalendar._buildCalendarMonthScaffold(d, tab.find(".cal-months"), this.cols);

            for (; Zp.weekday(d) != Zp.weekdayStart[Zp.cult];) d--;
            for (; Zp.toParts(d).day != 1; d++) calDays.append('<li class="cal-day cal-unselectable"></li>');
            if (d - 1 < todayLimit) tab.find(".cal-prev").hide();
            do {
                let el = $('<li class="cal-day"></li>');
                calDays.append(el);
                const status = this.availStatus(d);
                const day = Zp.toParts(d).day;
                if (d >= todayLimit) {
                    if (status === 1) el.addClass("cal-green");
                    el = $('<a></a>').appendTo(el.attr("data-date", d));
                } else {
                    el = $("<span></span>").appendTo(el.addClass("cal-unselectable"));
                }
                el.text(day);
                d++;
            } while (Zp.toParts(d).day != 1)
        }

        const lis = tab.find("li[data-date]");
        const that = this;
        if (this.clickEvent) {
            lis.on("click", function () {
                const el = $(this) as JQuery<HTMLLIElement>;
                that.clickEvent(el, el.data("date"))
            });
        }
        if (this.hoverEvent) {
            lis.on("mouseover", function () {
                const el = $(this) as JQuery<HTMLLIElement>;
                that.hoverEvent(el, el.data("date"), true)
            });
            lis.on("mouseout", function () {
                const el = $(this) as JQuery<HTMLLIElement>;
                that.hoverEvent(el, el.data("date"), false)
            });
        }

        return tab;
    }
}
